<template>
  <div class="background">
    <v-main :style="style" id="main_content" tabindex="-1">
      <router-view />
    </v-main>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapStores, mapWritableState } from 'pinia';
import { useGlobalStore } from '@/stores/global/global.store';

export default defineComponent({
  data: () => ({}),
  computed: {
    ...mapStores(useGlobalStore),
    ...mapWritableState(useGlobalStore, ['rootLoading']),
    style() {
      const style = {
        paddingTop: 0,
        paddingBottom: '96px',
      };
      return style;
    },
  },
  mounted() {
    this.rootLoading = false;
  },
});
</script>

<style lang="scss" scoped>
.background {
  min-height: 100%;
  background-image: linear-gradient(to top, #607c97, #063562);
}

.return-home-link {
  color: #fff !important;

  .v-icon {
    color: #fff;
    font-size: 2em;
    line-height: 0.6em;
    margin-left: -8px;
  }
}

#alerts {
  position: -webkit-sticky;
  position: sticky;
  top: 4rem;
  z-index: 1;
}
</style>
